import { autoinject } from 'aurelia-framework';
import { BaseDevice } from "./base-device";
import { Device } from "../../../models/device";
import { Store } from "aurelia-store";
import * as State from "../../../store/state";
import IState = State.IState;
import { Api } from "../../../services/api";

@autoinject
export class SensumSoilMoisture extends BaseDevice {
 
	constructor(store: Store<IState>, api: Api) {
		super(store, api);
	}

  activate(device: Device) {
	 this.device = device;
  }

}